import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import content from '../content/site-content.ko.json';
import './SiteHeader.css';

const getLogoPath = (filename) => {
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}/images/${filename}`;
};

function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
    setIsScrolled(window.scrollY > 40);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navClass = `site-header ${isScrolled ? 'site-header--scrolled' : ''}`;
  const logoFile = isScrolled ? 'logo-612w.png' : 'logo-612c.png';

  return (
    <header className={navClass}>
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand">
          <img src={getLogoPath(logoFile)} alt="작은별612" className="site-header__logo" />
        </Link>

        <nav className={`site-header__nav ${isMenuOpen ? 'is-open' : ''}`}>
          <ul>
            {content.nav.map((item) => (
              <li key={item.label}>
                <Link to={item.href}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="site-header__actions">
          <Link to={content.navCta.href} className="site-header__cta">
            {content.navCta.label}
          </Link>
          <button
            type="button"
            className={`site-header__toggle ${isMenuOpen ? 'is-open' : ''}`}
            aria-label="메뉴"
            onClick={() => setIsMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}

export default SiteHeader;
